import { omit } from "./object";

export function parseJsonOrNull(json: string): unknown | null {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function omitJsonObjectFieldsOrNull({
  json,
  fields,
}: {
  json: string;
  fields: string[];
}): string | null {
  const parsedJson = parseJsonOrNull(json);
  if (
    typeof parsedJson !== "object" ||
    parsedJson === null ||
    Array.isArray(parsedJson)
  ) {
    return null;
  }

  return jsonStringifyOrNull(
    omit(Object.fromEntries(Object.entries(parsedJson)), fields),
  );
}

export function jsonStringifyOrNull(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  try {
    return JSON.stringify(value);
  } catch {
    return null;
  }
}
